<div *ngIf="law" class="moving">
  <layer-header
    (closeLayer)="closeLayer()"
    [listIcons]="false"
    [title]="law.id ? 'Edit Law' : 'Add Law'"
  >
    <ng-content></ng-content>
  </layer-header>
  <div class="row">
    <div class="col-12">
      <form name="itemForm" role="form">
        <div class="row mb-lg-3">
          <div class="col-lg-6 col-md-12 mb-3 mb-lg-0">
            <label class="input-label field-required">{{
              'Law Name' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="name"
              [(ngModel)]="law.name"
              #name="ngModel"
              [rangeLength]="[2, 256]"
              required
              (input)="isNew(law.id) || nameChanged($event.target.value)"
            />
            <p
              class="validation-error"
              *ngIf="name && name.errors?.required && (name?.dirty && name?.touched)"
            >
              {{ 'form.validate.required' | translate }}
            </p>
            <p class="validation-error" *ngIf="name && name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p class="validation-error" *ngIf="name && name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 256!
            </p>
          </div>
          <div class="col-lg-6 col-md-12 mb-3 mb-lg-0">
            <label class="input-label">{{
              'Law Short Name' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="shortName"
              [(ngModel)]="law.shortName"
              #shortName="ngModel"
              [rangeLength]="[2, 20]"
              minlength="2"
              maxlength="20"
            />
            <p class="validation-error" *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && shortName?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p class="validation-error" *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && shortName?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 20!
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-4">
            <primary-text-button
              (onClick)="submit()"
              [disabled]="
                isLoading ||
                (name && name.invalid) ||
                (shortName && shortName.invalid)
              "
            >
              {{ 'Save' | translate }}
            </primary-text-button>
            <cancelary-text-button (click)="closeLayer()">
              {{ 'Cancel' | translate }}
            </cancelary-text-button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="input-label">{{ 'annexes.file' | translate }}</label>
            <div>
              <span *ngIf="law.fileId && fileMetadata" class="text-muted">{{
                fileMetadata.filename
              }}</span>
              <i
                *ngIf="law.fileId"
                (click)="download(law)"
                tooltip="{{ 'annexes.download_file' | translate }}"
                download
                class="fa fa-file list-group-item-v2__edit"
              ></i>
              <label
                class="fa fa-paperclip list-group-item-v2__edit ml-0"
                tooltip="{{ 'annexes.upload_file' | translate }}"
                style="margin-bottom: 0;color:#f78b95;cursor:pointer"
              >
                <file-uploader
                  [item]="law"
                  (fileIdChanged)="handleUpload($event, law)"
                ></file-uploader>
              </label>
              <i
                *ngIf="law.fileId"
                tooltip="{{ 'annexes.erase_file' | translate }}"
                class="fa fa-eraser list-group-item-v2__edit services-icon--dangerous"
                (click)="deleteFile(law)"
              ></i>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
